/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */

import {
    AddEditGlobalNamesComponent,
    AddEditMembersComponent,
    AddEditPoolsComponent,
    AddEditTopologyComponent
} from './addEdit';
import { AuthGuard } from '../../../../../core/guards';
import { GlobalNamesDomainValidationDirective } from '../../../shared/directives/validation';
import { GslbApiService } from '../../../shared/http';
import { GslbComponent } from './gslb.component';
import {
    GslbGlobalNameResolver,
    GslbMembersResolver,
    GslbPoolsResolver,
    GslbTopologiesResolver
} from '../../../shared/resolvers';
import { LoadbalancerSharedModule } from '../../../shared/loadbalancer.shared.module';
import { NgModule } from '@angular/core';

/**
 *
 */
@NgModule({
    imports: [
        LoadbalancerSharedModule
    ],
    declarations: [
        AddEditGlobalNamesComponent,
        AddEditMembersComponent,
        AddEditPoolsComponent,
        AddEditTopologyComponent,
        GlobalNamesDomainValidationDirective,
        GslbComponent
    ],
    exports: [
        GslbComponent
    ],
    providers: [
        AuthGuard,
        GslbGlobalNameResolver,
        GslbMembersResolver,
        GslbPoolsResolver,
        GslbTopologiesResolver,
        GslbApiService
    ]
})

export class GslbModule {
}
